import { useRef } from 'react';
/**
 * @function useDebounce
 * @since 1.0.0
 */
export function useDebounce(debounced, delay = 16 * 5) {
    const callback = useRef(debounced);
    const throttle = useRef(null);
    callback.current = debounced;
    /**
     * @function cancel
     * @since 1.0.0
     * @hidden
     */
    function cancel() {
        if (throttle.current) {
            throttle.current = clearTimeout(throttle.current);
        }
    }
    /**
     * @function attach
     * @since 1.0.0
     * @hidden
     */
    function attach(args) {
        throttle.current = setTimeout(() => {
            if (callback.current) {
                callback.current.apply(null, args);
            }
        }, delay);
    }
    return function (...args) {
        cancel();
        attach(args);
    };
}
